import { Edit, SimpleForm, useRedirect, useNotify, useRefresh } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";
import { PAID } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditPaidCampaign = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();

  const campaignSave = async data => {
    try {
      await dataProvider.update(candidateRequests.campaignByType(PAID), { id: data.id, data: data });
      notify("Успешно редактиране", { type: "success" });
      redirect("list", candidateRequests.campaignByType(PAID));
      refresh();
    } catch (error) {
      console.error(error);
      notify(`Error: ${error.message || "Грешка при редактиране"}`, { type: "error" });
    }
  };

  return (
    <Edit
      title="Редакция на платена кампания"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm
        toolbar={<InactiveDeleteOptionEditToolbar />}
        onSubmit={campaignSave}
      >
        <SaveForm isEdit />
      </SimpleForm>
    </Edit>
  );
};
export default EditPaidCampaign;
